module.exports = __webpack_public_path__ + "static/img/19078D_1_2_C_20210327_LC.eacb503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19078D_1_2_C_20210327_LC.png
// module id = 718P
// module chunks = 0